<template>
	<toolbar>

		<h2><i class="fa fa-envelope"></i> Messages</h2>

		<div class="controls">
			<div class="mr-2">
				<template v-if="$route.name == 'Messages'" >
					<search-bar placeholder="Search threads..."
						class="search-threads" 
						v-on:submit="searchThreads"
						v-on:clearSearch="clearSearch">		
					</search-bar>
					<label>
						<input type="checkbox" v-model="includeMessages">
						Include messages in search
					</label>
				</template>
			</div>

			<button v-on:click="newThread" class="btn btn-success new-message">
				<i class="fa fa-plus"></i>
				<i class="fa fa-envelope"></i>
			</button>
		</div>

	</toolbar>
</template>

<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import ContextMenu from "@/layout_fragments/ContextMenu"
import SearchBar from "@/components/SearchBar"

export default {
	name: "MessagesToolbar",
	components: {
		Toolbar,
		ContextMenu,
		SearchBar
	},
	data() {
		return {
			includeMessages: false
		}
	},
	methods: {
		newThread() {
			this.$bus.$emit("newThread")
		},
		searchThreads(terms) {
			this.$bus.$emit("searchThreads",{
				terms,
				includeMessages: this.includeMessages
			})
		},
		clearSearch() {
			this.$bus.$emit("clearSearch")
		}
	}
}
</script>

<style type="text/css">

</style>